import { startOfDay } from 'date-fns';
import { Button } from 'seagull';
import { createEmptyChargeItem } from "../../../../components/BillClientModal/BillClientItem.utils";
import BillClientModal from "../../../../components/BillClientModal/BillClientModal";
import { useOverlayContext, useIoContext, useStoreActions } from "../../../../contexts";
import { Intent } from "../../../../infra/access-control";
import { timeModel } from "../../../../models";
import AddCreditModal from "../../../../components/AddCreditModal/AddCreditModal";
import styles from "./BillingControl.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BillingControlFooter(props) {
  const {
    agreement,
    invoiceDateInfo,
    earliestBillableDate,
    controlData
  } = props;
  const {
    manualServices,
    totalCredits
  } = props.controlData;
  const {
    logBI
  } = useStoreActions();
  const {
    getNow
  } = useIoContext();
  const overlayContext = useOverlayContext();
  const onAddCredit = () => {
    logBI(18000);
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(AddCreditModal, {
          relationship: agreement,
          nextBillingDate: timeModel.toDateStampObject((invoiceDateInfo === null || invoiceDateInfo === void 0 ? void 0 : invoiceDateInfo.selectedDate) || startOfDay(getNow())),
          dismissModal: dismissModal
        });
      }
    });
  };
  const onAddCharge = () => {
    logBI(10566);
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(BillClientModal, {
          dismissModal: dismissModal,
          relationshipId: agreement.id,
          invoiceDateInfo: invoiceDateInfo,
          totalCredits: totalCredits,
          earliestBillableDate: earliestBillableDate,
          defaultItem: createEmptyChargeItem(),
          manualServicesBilling: manualServices,
          controlData: controlData
        });
      }
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.footer,
    children: [/*#__PURE__*/_jsx(Button, {
      className: styles.footerBtn,
      skin: "primaryOutline",
      onClick: onAddCharge,
      "data-testid": "add-charge-button",
      intent: Intent.AddCharge,
      children: "Add Charge"
    }), /*#__PURE__*/_jsx(Button, {
      className: styles.footerBtn,
      skin: "primaryOutline",
      onClick: onAddCredit,
      "data-testid": "add-credit-button",
      intent: Intent.AddCredit,
      children: "Add Credit"
    })]
  });
}